<template>
    <v-card>
        <v-form
            ref="providerGroupForm"
            v-model="isValid"
        >
            <v-card-text>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule,lengthRule(50)]"
                                label="Name"
                                v-model="providerGroup.name"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                    <v-btn
                            :disabled="isLoading && !isDeleting"
                            :loading="isDeleting"
                            @click="deleteEntity"
                            class="text-none"
                            color="warning darken-1"
                            text
                            v-show="providerGroup.id > 0"
                        >Delete</v-btn>
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-btn
                            :disabled="isLoading && !isSaving"
                            :loading="isSaving"
                            @click="saveEntity"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >{{providerGroup.id > 0 ? "Update" : "Add"}}</v-btn>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
import ProviderGroup from "../../models/ProviderGroup.model";
export default {
    props: {
        providerGroupIn: ProviderGroup
    },
    components: {
        //
    },
    data() {
        return {
            providerGroup: new ProviderGroup().set(this.providerGroupIn),
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters"
        };
    },

    methods: {
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedProviderGroup) {
            this.$emit("saved", savedProviderGroup);
        },
        emitDeletedEntity(deletedProviderGroup) {
            this.$emit("deleted", deletedProviderGroup);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.providerGroupForm.validate();
            return this.isValid;
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                this.$store
                    .dispatch(
                        "providerGroups/" +
                            (this.providerGroup.id == 0 ? "create" : "update"),
                        this.providerGroup
                    )
                    .then(
                        providerGroupWithInfo => {
                            this.notify(
                                "ProviderGroup successfully saved.",
                                "success"
                            );
                            if (this.providerGroup.id == 0) {
                                this.providerGroup.id = providerGroupWithInfo.entity.id;
                            }
                            this.emitSavedEntity(providerGroupWithInfo);
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this providerGroup?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("providerGroups/delete", this.providerGroup.id)
                    .then(
                        () => {
                            this.notify(
                                "ProviderGroup successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.providerGroup);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>